import {getInstitutionCode, getVid, isHoldingsDisplayInLocationsList} from '../../../../../appConfig/appConfigForward';
import {Injectable, Inject} from 'ng-metadata/core';
import {ConfigurationUtil} from '../../../../../nddUtils/configurationUtil.service';
import {OpacService}  from '../opac.service';
import {LocationItemDisplay,LocationBuilder} from './locationItemModel.service';
import {LocationsFilterService} from '../locationsFilter/locationsFilter.service';
import {MappingTablesCache} from '../../../../../mappingTablesCache/mappingTablesCache.service';
import {JwtUtilService} from '../../../../../security/jwtUtil.service';
import { RequestServicesService } from '../request/requestsService.service';
import {LocationService} from './location/location.service';
import {userRegisteredToOtherInstitution} from "../../almaOtherMembers/almaOtherMembers.directive";
const filter = require('lodash/filter');
const cloneDeep = require('lodash/cloneDeep');
const forEach = require('lodash/forEach');
const get= require('lodash/get');
const uniq= require('lodash/uniq');


@Injectable()
export class Location{
    public location;
    public items:Array<FieldsPerItem> = [];
    public summaryHoldings:SummaryShort;
    public isHoldingExpandedData:boolean = false;
    public adaptor:string;
    public isMore: boolean;
    public nextStartPos:number;
    public locationNoItems:boolean = false;
    public isExpandAll:boolean = false;
    public services;

    constructor(location) {
        this.location = location;
        this.isExpandAll = false;
    }

}

@Injectable()
export class FieldsPerItem{
    public item:string;
    public itemFields:Array<string> = [];
    public fullItemFields:Array<string> = [];
    public fullItemValues:Array<string> = [];
    public isExpanded = false;
    public listOfServices = [];

    constructor(item, itemFields, fullItemFields, fullItemValues, isExpanded, listOfServices,
                private _additionalData) {
        this.item = item;
        this.itemFields = itemFields;
        this.fullItemValues = fullItemValues;
        this.isExpanded = isExpanded;
        this.listOfServices = listOfServices;
    }

    get additionalData() {
        return this._additionalData;
    }
}

@Injectable()
export class SummaryShort{
    public baseSummaryShort:Array<string>;
    public allLines:Array<string> = [];

    constructor(baseSummaryShort, allLines) {
        this.baseSummaryShort = baseSummaryShort;
        this.allLines = allLines;
    }
}
@Injectable()
class KeyValue{
    public key:string;
    public value:string;

    constructor(key, value){
        this.key = key;
        this.value = value;
    }
}

@Injectable()
export class LocationsService {
    public inst : String;
    public isItemsResquestInProgress:boolean;
    private vid: string = getVid();
    private line:string = '';
    private lineData:string = '';
    private bulkSize: number = 0;
    private svcId: number;
    private filtersMode: boolean = false;

    constructor(private configurationUtil: ConfigurationUtil,
                private opacService: OpacService,
                private mappingTablesCache : MappingTablesCache,
                private locationBuilder : LocationBuilder,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('restBaseURLs') private restBaseURLs: Object,
                private locationsFilterService : LocationsFilterService,
                private jwtUtilService: JwtUtilService,
                private requestServicesService: RequestServicesService,
                private locationService:LocationService,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                @Inject('$rootScope') private $rootScope: ng.IRootScopeService) {
            this.configurationUtil = configurationUtil;
            this.opacService = opacService;
            this.jwtUtilService = jwtUtilService;
            this.confInit();
            this.requestServicesService = requestServicesService;

    }

    public clearItemsForDisplay () {
        this.itemsForDisplay = [];
    }

    public getLocations(items) {    //!!!!!! search for setLocations in project (rta)
        this.clearItemsForDisplay();
        let instSort = this.configurationUtil.getLocationsConfiguration().instsort;
        let onlyViewInst = this.configurationUtil.getLocationsConfiguration().viewinstsort;
        let globalitemsList = items.delivery.holding;
        globalitemsList = (globalitemsList || []).filter((loc)=>{return (!onlyViewInst || loc.organization === getInstitutionCode());});
        this.svcId = items.delivery.physicalServiceId;

        let userInst = this.jwtUtilService.getDecodedToken().institution;
        let locations = [];
        if (instSort) {
            let userInstitemsList = [];
            let otheritemsList = [];
            globalitemsList.forEach((location) =>{
                if (location.organization === userInst) {
                    userInstitemsList.push(new Location(location));
                } else {
                    otheritemsList.push(new Location(location));
                }
            });
            locations.push(userInstitemsList);
            locations.push(otheritemsList);
        } else {
            let globalLocationsList = globalitemsList.map((loc)=>{return new Location(loc);});
            locations.push(globalLocationsList);
        }
        return locations;
    }

    private getIndexFieldExists(summaryFieldsContent, field){
        let ind = -1;
        summaryFieldsContent.forEach((f, index)=> {
            if (field === f.key) {
                ind=index;
            }
        });
        return ind;
    }

    private getOrUpdateCurrentHolding(summaryFieldsContent, field, holdingsFields, loc){
        let obj;
        let index = this.getIndexFieldExists(summaryFieldsContent, field);
        if (index !== -1){//exists - should update the appropriate entry
             loc.isHoldingExpandedData = true;
             summaryFieldsContent[index].value = summaryFieldsContent[index].value.concat(holdingsFields[field]);
        } else {//does not exist - setting and then returning the new entry
            obj = new KeyValue(field, holdingsFields[field]);
        }
        return obj;
    }

    private getLocationSummaryHoldings(holdingsInfo, adaptor, loc) {
        let summaryFieldsContent = [];
        let baseSummaryShort = [];
        let noOfItemsInBase = 0;
        holdingsInfo.map((holding)=>{
            let holdingsFields = holding['location-fields'];
            let locFieldsList = holding['location-fields-list'];
			let isCustomoized = false;
            let currentSummaryHolding = [];
            currentSummaryHolding = locFieldsList.map((field) => {
	            if (field.includes('loc.customized')){
	            	isCustomoized = true;
	            	if (holdingsFields[field] && summaryFieldsContent.length === 0) {
		            	return holdingsFields[field];
		            }
	       	 	} else {
		                if(holdingsFields[field]){
		                    holdingsFields[field] = holdingsFields[field].filter(f => f !== undefined && f.trim() !== '');
		                }
	            		if (holdingsFields[field] && summaryFieldsContent.length === 0) {
	                        loc.isHoldingExpandedData = holdingsFields[field].length>1;
	                        return new KeyValue(field, holdingsFields[field]);
	                    //return this.getOrUpdateCurrentHolding(summaryFieldsContent, field, holdingsFields, loc);
						}
	            }
	            return undefined;
	        }).filter((f)=>{if (f !== undefined){ return f;}});

			if (isCustomoized){
				if (currentSummaryHolding.length > 1) {
					currentSummaryHolding = currentSummaryHolding[0].concat(currentSummaryHolding[1]);

				} else {
					currentSummaryHolding = currentSummaryHolding[0];
				}
			}
            summaryFieldsContent = summaryFieldsContent.concat(currentSummaryHolding);
        });

        summaryFieldsContent.map((fieldContent, index)=>{
            if (noOfItemsInBase < 3 && fieldContent !== undefined && fieldContent.value !== undefined) {
                let threeDots = fieldContent.value.length > 1? '...':'';
                loc.isHoldingExpandedData = loc.isHoldingExpandedData?loc.isHoldingExpandedData:fieldContent.value.length > 1;
                noOfItemsInBase++;
                baseSummaryShort.push(new KeyValue(fieldContent.key, fieldContent.value[0]+ threeDots));
            } else {
                loc.isHoldingExpandedData = true;
            }
        });

        loc.summaryHoldings = new SummaryShort(baseSummaryShort, summaryFieldsContent);
    }

    private getItemsList(items: Array<Object>){
        let itemsList = [];
        items.forEach((item) => {
           itemsList.push(new LocationItemDisplay(item, this.locationBuilder, this.vid));
        });
        return itemsList;
    }

    private calculateRequestParams(holdings, startPos, filtersCall, filters, hideResourceSharing = false){

        let ilsRecordList:Array<any> = [];
        let locations: Array<any> = [];
        let mainLoc = '';
        let collection = '';
        let holid = '';
        let holKey = '';
        let sublibs:string = '';
        let matchForHolding = '';
        let callNumber = '';

        holdings.map((holding)=>{
                holding.map((hold)=>{
                    if (!ilsRecordList.some((record)=> {
                            return record.recordId === hold.location.ilsApiId && record.institution === hold.location.organization;
                        })) {
                        ilsRecordList.push({'institution':hold.location.organization,'recordId':hold.location.ilsApiId});
                    }
                    locations.push(hold.location);
                    mainLoc = hold.location.mainLocation;
                    collection = hold.location.subLocationCode;
                    callNumber = hold.location.callNumber;
                    matchForHolding = '';
                    if(hold.location.matchForHoldings && hold.location.matchForHoldings.length > 0){
                        matchForHolding = hold.location.matchForHoldings[0].matchOn +
                            (hold.location.matchForHoldings[1]?',' + hold.location.matchForHoldings[1].matchOn : '');
                    }
                    holid = hold.location.holdId;
                    holKey = hold.location.holKey;
                    sublibs = sublibs + hold.location.mainLocation + ',';
                });
             sublibs = holding.length>0?sublibs.substring(0, sublibs.length-1):sublibs;
        });

        this.bulkSize = (this.bulkSize===0?this.locationBuilder.getShowMoreBulkSize():this.bulkSize);

        let noItems  = this.getNoItems(startPos, filters);

        let volume = get(filters, 'volume');
        let year = get(filters, 'year');
        let description = get(filters, 'description');

        let loc = {'filters': {'startPos': startPos,
        'noItem': noItems ,
        'sublibrary': sublibs.includes(',')?'':mainLoc,
        'collection': sublibs.includes(',') || matchForHolding !== 'MainLocation,SecondaryLocation'?'':collection,
        'callnumber': sublibs.includes(',') || matchForHolding !== 'MainLocation,CallNumber'?'':callNumber,
        'holid' : sublibs.includes(',')?'':holid,
        'sublibs': sublibs,
        'ilsRecordList':ilsRecordList,
        'vid': this.vid,
        'volume': volume !=='All'?volume:'',
        'year': year!=='All'?year:''
        },
        'locations': locations,
        'hideResourceSharing' : hideResourceSharing};
        if(this.configurationUtil.getBackendSystem() === 'suprima'){
            if(holdings.length > 1){
                loc.filters.holKey = holKey;
            }
            loc.filters.description = description!=='All'?description:'';
            loc.filters.filterCall = filtersCall;
        }
        return loc;
    }

    public getItems(loc, fromShowMore, filtersCall, filters, hideResourceSharing = false, envURL? : string){
        loc = loc || {} as Location;
        loc.nextStartPos = (loc.nextStartPos===undefined?1:loc.nextStartPos);
        loc.isMore = (loc.isMore===undefined?false:loc.isMore);
        let location = [[loc]];
        if(this.configurationUtil.getBackendSystem() === 'suprima'){
            filters=filters || {};
            filters.location = loc.location.libraryCode;
            if(this.locationsFilterService.isFilterClicked){
                filtersCall = true;
            }
        }

        return this.getLocationsItems(location, fromShowMore, filtersCall, filters, hideResourceSharing, envURL);

    }

    public getLocationsItems(loc, fromShowMore, filtersCall, filters, hideResourceSharing = false, envURL? : string) {
        let itemsForDisplay;
        if (!(loc && loc[0] && loc[0][0] && loc[0][0].items)) {
            return;
        }

        if (loc[0][0].nextStartPos === -1){//if there are no more records from ils - but one from prev call(there is show more)
            loc[0][0].isMore = false;//from now on - show more should be hidden - no more items
        }

        if (loc[0][0].nextStartPos !== -1 || filtersCall){//for single loc - first time or when there are more, OR for filters call
            let startPos = filtersCall?1:loc[0][0].nextStartPos;
            if (filtersCall || ((fromShowMore || loc[0][0].items.length === 0) && !loc[0][0].locationNoItems)){//calling the ils
                let requestParams = this.calculateRequestParams(loc, startPos, filtersCall, filters, hideResourceSharing);
                this.isItemsResquestInProgress = true;
                let suffix = '';
                if(this.configurationUtil.getBackendSystem() === 'suprima'){
                    if(this.svcId){
                        suffix = '/'+this.svcId;
                    }
                    if(loc[0][0].location && loc[0][0].location.organization){
                        suffix += '?record-institution='+loc[0][0].location.organization;
                    }
                    if(envURL){
                        suffix += '&envURL='+encodeURIComponent(envURL);
                    }
                }
                return this.opacService.makeIlsRequest('locations', requestParams,'POST',suffix)
                .then((res) =>{
                    if(this.configurationUtil.getBackendSystem() === 'suprima'){
                        this.processSuprimaLocationsResponse(loc, res, startPos, filtersCall,filters);
//                        this.requestServicesService.putLocationServices(get(res, 'data.itemInfo.locations[0].holKey'),res.data);
//                        this.requestServicesService.restoreServices();
//                        this.requestServicesService.useLocationServices(res.data.itemInfo.locations[0].holKey);
//                        this.updateServicesList();
                    }else{
                        this.processResponse(loc, res, startPos, filtersCall, filters);
                    }
                    return res;
                }, (reason) => {
                    console.log('Load locations failed: ',reason);
                    this.isItemsResquestInProgress = false;
                });
            }
        }
    }

    private getNoItems(startPos, filters) {
        let noItems = this.bulkSize;

        if (filters && (filters.volume && filters.volume !== 'All' || filters.year && filters.year !== 'All' || filters.description && filters.description !== 'All')) {
            return noItems;
        }

        if (startPos === 1) {
            noItems = this.locationBuilder
              .getLocationsConfig('Location Item content','item.brief.number_of_items', this.vid)[0].target;
        }

        noItems  = Number(noItems) + ((startPos===1) ? Number(1) : Number(0));

        return noItems;
    }

    private processSuprimaLocationsResponse(loc:Array<Array<Location>>, res, startPos, filtersCall, filters){
        let resp;
        if(res.data && res.data.itemInfo){
            resp = res.data.itemInfo;
            loc[0][0].services = res.data;
            if(filtersCall && resp.locations.length > 1){
                resp.results = this.updateLocationsAfterFilter(loc,resp.locations);
                this.isItemsResquestInProgress = false;
                return;
            }
        }else{
            resp = res;
        }
        this.processResponse(loc, resp, startPos, filtersCall, filters);
    }

    private updateLocationsAfterFilter(loc,locationsAfterFilter) {
        let instSort = this.configurationUtil.getLocationsConfiguration().instsort;
        let onlyViewInst = this.configurationUtil.getLocationsConfiguration().viewinstsort;
        let locations = [];
        let userInstitemsList = [];
        locationsAfterFilter.forEach(
            (filtered) =>{
                loc[0].forEach(
                    (unfiltered) =>{
                        if(unfiltered.location.holKey === filtered.holKey){
                            if(!(unfiltered.length>10) && isHoldingsDisplayInLocationsList() && filtered.holdings) {
                                this.getLocationSummaryHoldings(filtered.holdings, filtered.adaptorid, unfiltered);
                            }
                            userInstitemsList.push(unfiltered);
                        }
                    }
                );
            }
        );
        locations[0] = userInstitemsList;

        return locations;
    }

    private processResponse(loc:Array<Array<Location>>, res, startPos, filtersCall, filters){
        let items;
        let adaptor;
        let holdingsInfo;
        try {
            res.locations.map((singleLoc)=> {
                let location:Location;

                let loc11;
                let location1 = loc.map((l)=>{
                    loc11 = l.filter((ll)=>{
						if(this.configurationUtil.getBackendSystem() === 'suprima'){
							return (ll.location.libraryCode === (singleLoc['library-code']?singleLoc['library-code']:'')
                                && ll.location.subLocationCode === (singleLoc['sub-location-code']?singleLoc['sub-location-code']:'')
                                && ll.location.organization === (singleLoc.organization ? singleLoc.organization : '')
                                && ll.location.holdId === (singleLoc['hold-id'] ? singleLoc['hold-id'] : '')
                                && ll.location.callNumber === (singleLoc['call-number'] ? singleLoc['call-number'] : '')
                        	);
						}else{
							return (ll.location.ilsApiId === (singleLoc['ils-api-id']?singleLoc['ils-api-id']:'')
                                && ll.location.libraryCode === (singleLoc['library-code']?singleLoc['library-code']:'')
                                && ll.location.subLocationCode === (singleLoc['sub-location-code']?singleLoc['sub-location-code']:'')
                                && ll.location.organization === (singleLoc.organization ? singleLoc.organization : '')
                                && ll.location.holdId === (singleLoc['hold-id'] ? singleLoc['hold-id'] : '')
                                && ll.location.callNumber === (singleLoc['call-number'] ? singleLoc['call-number'] : '')
                        	);	
						}
                    });
                    if(this.configurationUtil.getBackendSystem() === 'suprima' && get(loc11, '[0]')){
                        loc11[0].location.availabilityStatement = singleLoc.availabilityStatement;
                    }
                    return loc11;
                });
                if(get(location1, '[0][0]') || get(location1, '[1][0]'))  {
                    location = location1[0][0] ? location1[0][0] : location1[1][0];//getting the appropriate location

                    items = singleLoc.items;

                    if (!items || items.length === 0) {
                        location.items = [];
                        location.locationNoItems = (startPos === 1 ? true : location.locationNoItems);
                    } else {
                        let partial = singleLoc.partial;
                        //-1 means that there is no need to call the api next time- since we have the extra item and there is no more
                        location.nextStartPos = partial ? singleLoc['current-start-pos'] : -1;
                        //if you got 1 more than what you display => there are more items to display
                        let noItems = this.getNoItems(startPos, filters);
                        location.isMore = singleLoc.items.length === noItems;
                    }
                    adaptor = singleLoc.adaptorid;
                    holdingsInfo = singleLoc.holdings;

                let itemsForDisplay = this.processHoldings(items, holdingsInfo, adaptor, location, filtersCall, loc);
                if (itemsForDisplay.length > 0){
                    location.items = filtersCall ? itemsForDisplay:location.items.concat(itemsForDisplay);
                    if (!filtersCall) {
                        loc.map((res)=>{res.map((curLoc)=>{if (location.location.ilsApiId === curLoc.location.ilsApiId
                                                                && location.location.libraryCode === curLoc.location.libraryCode
                                                                && location.location.mainLocation === curLoc.location.mainLocation
                                                                && location.location.subLocationCode === curLoc.location.subLocationCode
                                                                && location.location.organization === curLoc.location.organization
                                                                && location.location.callNumber === curLoc.location.callNumber
                                                                && location.location.holdId === curLoc.location.holdId
                                                                ) {curLoc.items = (curLoc.items.length===0)?location.items:curLoc.items}});});

                        }
                    }
                }
            });

            loc = loc.map(l => {
                const filtered = l.filter(ll => ll.items.length > 0);
                return filtered.length > 0 ? filtered : l;
            });

            res.results= loc;
            if (loc.length === 1) {
                console.log('in order to update currentLoc for loc items view (when filtering from loc items - it doesn\'t pass the loc view so should update currentLoc)');
                //this.setLocItems(false);
            }

            this.isItemsResquestInProgress = false;


        } catch(e){
            this.isItemsResquestInProgress = false;
            console.log(e);
            return null;
        }


    }

    private processHoldings(items, holdingsInfo, adaptor, location, filtersCall, loc) {
        let locItems = this.getItemsList(items);

        let itemsForDisplay = items.length>0 ? this.processItems(locItems, filtersCall, loc) : [];
        if (holdingsInfo && holdingsInfo.length > 0) {
            this.getLocationSummaryHoldings(holdingsInfo, adaptor, location);
        }
        return itemsForDisplay;
   }

    private processItems(locItems, filtersCall, loc) {
        let additionalFields = this.locationBuilder.getFullDisplayFields();
        let itemsForDisplay = this.getItemsForDisplay(locItems, additionalFields, filtersCall, loc);

        return itemsForDisplay;
}

    private getItemsForDisplay(items, additionalFields, filtersCall, loc) {
        let briefFields = this.locationBuilder.itemsListConf;
        return items.map((item)=>{return this.parseItemsDisplay(item, briefFields, additionalFields, filtersCall, loc);});
    }
    private confInit(){
        this.locationBuilder.getBriefDisplayFields(this.vid);
    }

    private parseItemsDisplay(item, briefFields, additionalFields, filtersCall, loc){
        let delimiter = '';
        let fields = [];
        briefFields.map((fieldParts, index)=>{
            let line = '';
            fieldParts.map((field)=>{
                if (field) {
                    let briefField = field.split(' ');
                    briefField.map((singleField)=>{
                        if(singleField){
                            let data1= item[singleField.replace(/_/g, '')];
                            delimiter = fieldParts[3]==='&nbsp' || fieldParts[3]==='&nbsp;' ?' ':fieldParts[3];
                            delimiter = delimiter.replace(/&nbsp;|&nbsp/g, " ");       //replace ALL the occurences '&nbsp' and '&nbsp;' to space. [For example '&nbsp:&nbsp' to ' : ']
                            if (data1 && data1!=='') {
                                line += data1+ delimiter;//concat data + delimiter
                            }
                        }
                    });
                }
            });
            fields[index] = line.substr(0, line.lastIndexOf(delimiter));//removing the last delimiter
        });

        let allowedServices = this.getAllowedServices(item.listofservices.service);

        delimiter = ' ';
        let fullItemFields = [];
        let fullItemValues = [];
        additionalFields.map((additionalField)=>{
            if (additionalField[1]) {
                let fullItem = additionalField[1].split(' ');
                return this.$translate(additionalField[0]).then((translation)=> {
                    this.line = '';
                    this.lineData = '';
                    let label = translation ? translation + ': ' : '';
                    for (let i=0; i < fullItem.length; i++){
                        if(fullItem[i]){
                            let field = fullItem[i].replace(/_/g, '');
                            let data1= item[field];
                            this.line += (data1 && data1 !== '')?label + data1 + delimiter:'';//concat data + delimiter
                            this.lineData += (data1 && data1 !== '') ? data1 + delimiter:'';
                            if (this.line !== '') {
                                label = '';
                            }
                        }
                    }
                    this.line = this.line.substr(0, this.line.lastIndexOf(delimiter));//removing the last delimiter
                    this.lineData = this.lineData.substr(0, this.lineData.lastIndexOf(delimiter));

                    if (this.line !== '') {

                        loc.map((curLoc)=>{
                            curLoc.map((l)=>{
                                l.items.map((i)=>{
                                    if (item.itemid === i.item && !i.fullItemFields.some((fi)=>{return fi === this.line;})){
                                        i.fullItemFields.push(this.line);
                                        i.fullItemValues.push(this.lineData);
                                    }
                                });
                            });
                        });
                    }
                });
            }
        });

        /* PRM-30164
         * Hold request, item level, unnecessary fields are displayed
         * Manually, add item_description, item_category, item_status
         * Those parameters will be sent to the (item level) request service
         */
        let itemAdditionalFields = this.createItemAdditionalFields(item);

        return new FieldsPerItem(item.itemid, fields, fullItemFields, fullItemValues, item.isExpanded, allowedServices, itemAdditionalFields);

    }

    private createItemAdditionalFields(item) {
        let parameterNames =['itemid','itemdescription','mainlocationname',
                             'secondarylocationname','callnumber','itemcategoryname','itemstatusname'];
        let parametersMap = {};
        forEach(parameterNames, (parameter) => {
            parametersMap[parameter] = item[parameter];
        });
        return parametersMap;
    }

    private getAllowedServices(services) {
        return services.filter((service)=>{
            if (service.allowed === 'Y') {
                return service;
            }
        });
    }

    private updateServicesList() {
        forEach(this.requestServicesService.services.serviceinfo, (value, key) => {
            let service = {
               'path': value['link-to-service'],
               'method': 'GET',
               'serviceType': value['service-type']
           };
            this.opacService.updateService(value.type, service);
        });
    }

    clearFilters(record, fromLocItems:boolean){
        this.filtersMode = false;

        if (fromLocItems) { //should update currentLoc as well
           this.locationsFilterService.setFilterDropDownOptions(record);
        }
    }

    public performFilter(filters,unfilteredResults, hideResourceSharing = false, envURL? : string){
        this.filtersMode = true;
        let results = cloneDeep(unfilteredResults);
        let promise;
        if(!filters){
            filters = {
                volume: this.locationsFilterService.volumeFilter,
                year: this.locationsFilterService.yearFilter,
                description: this.locationsFilterService.descriptionFilter
            };
        }

        if (filters.location){
            results= this.filterLocation(filters.location, results);
            if(filters.subLocationCode) {
                results = this.filterBySubLocation(filters.subLocationCode, results);
            }
            if(this.configurationUtil.getBackendSystem() === 'suprima'){
                promise = this.filterYearAndVolume(filters.volume, filters.year, filters.description, results, hideResourceSharing, envURL);
            }
        }else if (filters.volume || filters.year || filters.description) {
            promise = this.filterYearAndVolume(filters.volume, filters.year, filters.description, results);
        }

        if (!promise) {
            promise = new Promise((resolve, reject) => {
                setTimeout(function() {
                    resolve({results: results});
                }, 100);
            });
        }
        return promise;
    }

    private filterLocation(location ,results){
        if (location === 'All') {
            return results;
        }
        results[0]= filter(results[0], (result)=>result.location.libraryCode===location);
        if(results[1]){
            results[1]= filter(results[1], (result)=>result.location.libraryCode===location);
        }
        return results;
    }

    private filterBySubLocation(subLocationCode, results) {
        if(!subLocationCode) {
            return results;
        }
        results[0] = filter(results[0], result => get(result, 'location.subLocationCode') === subLocationCode);
        if(results[1]) {
            results[1] = filter(results[1], result => get(result, 'location.subLocationCode') === subLocationCode);
        }
        return results;
    }

    public preFilterLocations(locationsFilter ,results){
        let filteredResults = cloneDeep(results);
        if(!locationsFilter || locationsFilter.length === 0){
            return filteredResults;
        }
        filteredResults[0]= filter(results[0], (result)=>locationsFilter.indexOf(result.location.libraryCode) > -1);
        if(results[1]){
            filteredResults[1]= filter(results[1], (result)=>locationsFilter.indexOf(result.location.libraryCode) > -1);
        }
        return filteredResults;
    }

    filterYearAndVolume(volume,year,description, results, hideResourceSharing = false, envURL? : string){
        return this.getLocationsItems(results, false,true, {volume: volume, year: year,description: description}, hideResourceSharing, envURL);
    }

    public updateFilterDropDownOptions(possibleFilters,locations){
        if (!possibleFilters || !locations) {
            return {};
        }

        let locationsObj = locations.map((location)=> location['library-code']+":"+this.locationService.getLibraryName(location));
        let dropDownOptions = {
                years: uniq(possibleFilters.years),
                volumes: uniq(possibleFilters.volumes),
                descriptions: uniq(possibleFilters.descriptions),
                locations: uniq(locationsObj)
            };
        return dropDownOptions;
    }

    public getItemQueueData(itemId,institution){
        let serviceData = {} as PrimoResponse.Ils.IRequestService;
        let recordInstitution = '';
        if(institution){
            recordInstitution = '?record-institution='+institution;
        }
        serviceData['link-to-service'] = this.restBaseURLs['ILSServicesBaseURL'] + "/itemQueue/" + itemId+recordInstitution;
        return this.opacService.makeIlsCall(serviceData,'','GET')
            .then((res) => {
                return res;
            });
    }

    public registerManualLinkedUser(institution, envURL? : string) : Promise<any>{
        let serviceData = {} as PrimoResponse.Ils.IRequestService;
        serviceData['link-to-service'] = this.restBaseURLs['ILSServicesBaseURL'] + "/register?createLinkedAccount=true&record-institution=" + institution;
        if(envURL){
            serviceData['link-to-service'] += "&envURL="+encodeURIComponent(envURL);
        }
        return this.opacService.makeIlsCall(serviceData).then((res) => {
                if(res.userId) {
                    this.$rootScope.$broadcast(userRegisteredToOtherInstitution, institution);
                }
                return res;
            }
        );
    }

    public getLocationsPrefilterConf(){
        return this.mappingTablesCache.findByProperties('get it prefilter locations', {target: getVid()}).map((val)=> val.source1);
    }

    public tryReloadWithRegisterUser(memberInstName, confirm) {
        const _this = this;
        this.$mdDialog.show({
            templateUrl: 'components/search/fullView/getit/opac/locations/register-confirmation-dialog.html',
            controller: function() {
                this.hide = _this.$mdDialog.hide;
                this.confirm = confirm;
                this.memberInstName = memberInstName;
            },
            controllerAs: 'ctrl',
            multiple: true
        })
    }

}
//put here all angular1 modules the service is using
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locations/locations.service.ts